import { render, staticRenderFns } from "./direct-debit-file-container.vue?vue&type=template&id=042580a1&scoped=true&"
import script from "./direct-debit-file-container.ts?vue&type=script&lang=ts&"
export * from "./direct-debit-file-container.ts?vue&type=script&lang=ts&"
import style0 from "./direct-debit-file-container.scss?vue&type=style&index=0&id=042580a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042580a1",
  null
  
)

export default component.exports